import { render, staticRenderFns } from "./TreatmentPriceTier.vue?vue&type=template&id=5cfee60a&scoped=true&lang=pug&"
import script from "./TreatmentPriceTier.vue?vue&type=script&lang=js&"
export * from "./TreatmentPriceTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfee60a",
  null
  
)

export default component.exports